import React, { useEffect, useState } from 'react';
import { Dropdown, MenuProps } from 'antd';
import moment from 'moment';
import CallButton from '../components/_CallButton';
import { GeneralDataModel } from '../models/GeneralDataModel';
import '../assets/css/clients_p0003.css';


type Props = {
    client: any;
    onSelect: Function;
    action: Function;
    isAdmin: boolean;
};
// isAdmin
const ClientRow = (props: Props) => {
    const [clientItems, setClientItems] = useState<MenuProps['items']>([]);
    // console.log('ClientRow');
    const onSelect = (e: any) => {
        const ignoreList: string[] = [
            'cell customer-identificator',
            'cell customer-phone',
            'cell customer-email',
            'cell actions'
        ];
        console.log('onRowClick', e.target.parentElement.className);
        if (e.target.parentElement.className.indexOf('cell') >= 0) {
            if (ignoreList.indexOf(e.target.parentElement.className) >= 0) {
                return;
            }
            if (e.target.className =='pointer rtl' || e.target.className == 'cell actions') return;
            if (props.onSelect) {
                props.onSelect();
            }
        }
    }

    
    const onMenuClicked = async (action: string) => {
        if (props.action) {
            props.action(action, props.client.id)
        }
    }

    const getContactData = (target: string) => {
        let result: string = '';
        if (props.client.customerContactDetails && props.client.customerContactDetails.length > 0) {
            const customerContactDetails: any = props.client.customerContactDetails[0];
            switch (target) {
                // case 'emailAddress':
                //     result = customerContactDetails
                //     break;
            
                default:
                    result = customerContactDetails[target]
                    break;
            }
        }
        return result;        
    }
    
    const onCallStart = (e:any) => {
        e.stopPropagation();

        const phoneNumber = getContactData('number');
        if(phoneNumber) {
            new GeneralDataModel().speakComSendCall(phoneNumber,props.client.id);
        }
    }

    const getAddressData = () => {
        const addressData: any = {
            city: '',
            address: ''
        }
        if (props.client.customerAddresses && props.client.customerAddresses.length > 0) {
            const customerAddress: any = props.client.customerAddresses[0];
            addressData.city = customerAddress.city;
            let address: string = '';
            if(customerAddress.street){
                address += `רחוב ${customerAddress.street} `;
                if(customerAddress.houseNumber && customerAddress.houseNumber > 0) {
                    address += `${customerAddress.houseNumber}`;
                }
            }
            if(customerAddress.mailbox){
                address += `ת.ד. ${customerAddress.mailbox} `;
                
            }
            if(customerAddress.postalCode) {
                address += `${customerAddress.postalCode}`;
            }
            addressData.address = address;
        }
        return (
            <>
            <div className="description cell-value">
                {addressData.city}
            </div>
            <div className="description" style={{whiteSpace: 'initial'}}>
                {addressData.address}
            </div>
            </>
        )
    }

    const getCustomerAge = () =>{
        let age: number = 0
        if (props.client.dateOfBirth) {
            const today: moment.Moment = moment();
            // moment(props.client.dateOfBirth)
            const birthdate: moment.Moment = moment(props.client.dateOfBirth);
            age = today.diff(birthdate, 'years');
        }

        return age;
    }
     
    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={()=>{onMenuClicked('edit')}}
                >
                    ערוך
                </li>
            ),
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={()=>{onMenuClicked('delete')}}
                >
                    מחק
                </li>,
            key: '2',
        }
    ];

    useEffect(()=>{
        // console.log('isAdmin', props.isAdmin, props.client.id)
        if (props.isAdmin) {
            setClientItems([
                {
                    key: '1',
                    label: (
                        <li className="pointer rtl"
                            onClick={()=>{onMenuClicked('edit')}}
                        >
                            ערוך
                        </li>
                    ),
                },
                {
                    label: 
                        <li className="pointer rtl"
                            onClick={()=>{onMenuClicked('delete')}}
                        >
                            מחק
                        </li>,
                    key: '2',
                }
            ])
        } else {
            setClientItems([
                {
                    key: '1',
                    label: (
                        <li className="pointer rtl"
                            onClick={()=>{onMenuClicked('edit')}}
                        >
                            ערוך
                        </li>
                    ),
                }
            ])
        }
    },[props])

    return (
        <Dropdown menu={{ items: clientItems }} trigger={['contextMenu']}>
            <div className="data-card  client-item flex-space-between" onClick={(e: any)=>onSelect(e)}>
                {/* <div className="top-row flex-space-between flex-centered mobile-only">
                    <div className="top-icons flex-space-between flex-centered">
                        <div className="rating-icon">
                            <div className="icon"></div>
                            <div className="rating-value flex-centered flex-justify-center">
                                3
                            </div>
                        </div>
                        <div className="flex activity-tag">
                            10
                        </div>
                    </div>
                    <div className="action">
                        <div className="icon left-arrow"></div>
                    </div>
                </div> */}
                <div className="data-card-body flex-space-between">
                    <div className="cell customer-status short desktop-only">
                        <div className="rating-icon">
                            <div className="icon"></div>
                            <div className="rating-value flex-centered flex-justify-center">
                                0
                            </div>
                        </div>
                    </div>
                    <div className="cell customer-status short desktop-only">
                        <div className="flex activity-tag">
                            {props.client && props.client.policiesCount ? props.client.policiesCount : 0}
                        </div>
                    </div>
                    <div className="cell customer-name">
                        <div className="title">שם</div>
                        <div className="description cell-value" style={{whiteSpace: 'initial', fontWeight: 'bold'}}>
                            {props.client.fullName}
                        </div>
                    </div>
                    <div className="cell customer-identificator">
                        <div className="title">ח.פ / ת.ז</div>
                        <div className="description cell-value">
                            {props.client.identifier}
                        </div>
                    </div>
                    <div className="cell customer-date customer-birth-date">
                        <div className="title">תאריך לידה</div>
                        <div className="description cell-value">
                            {props.client.identityType != 3 && props.client.dateOfBirth ? moment(props.client.dateOfBirth).format('DD-MM-YYYY') : ''}
                        </div>
                    </div>
                    <div className="cell customer-age">
                        <div className="title">גיל</div>
                        <div className="description cell-value">
                            {props.client.identityType != 3 && props.client.dateOfBirth ? getCustomerAge() : ''}
                        </div>
                    </div>
                    <div className="cell customer-email">
                        <div className="title">אימייל</div>
                        <div className="description cell-value phone-number">
                            {getContactData('emailAddress')}
                        </div>
                    </div>
                    <div className="cell customer-phone">
                        <div className="title">טלפון</div>
                        <div className="description cell-value flex-space-between">
                            {getContactData('number')}
                            <CallButton onStart={(e:any)=>onCallStart(e)} user={{
                                        userName: `${props.client.fullName}`,
                                        userPhone: getContactData('number')
                                    }} />
                        </div>
                    </div>
                    <div className="cell customer-address">
                        <div className="title">כתובת</div>
                        
                        {getAddressData()}
                    </div>
                    <div className="cell">
                        <div className="title">סוכן</div>
                        <div className="description cell-value">
                            {/* אהוד נח */}
                        </div>
                    </div>
                    <div className="cell">
                        <div className="title">מטפל</div>
                        <div className="description cell-value">
                            {/* אהוד נח */}
                        </div>
                    </div>
                    <div className="cell actions">
                        <Dropdown menu={{ items: clientItems }}>
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </Dropdown>
    )
}

export default ClientRow;